import styled from 'styled-components';

export const Container = styled.div`
  display: inherit;
  position: relative;
`;

export const ContentContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 10;
`;
